import styled from "@emotion/styled";
import type { FC } from "react";
import React from "react";

const FootnoteText = styled.p`
  order: 90;
  margin: 1.5em 0 0;
  text-align: center;
  color: var(--Greys-Charcoal80, rgba(33, 33, 33, 0.8));
`;

/**
 * Renders the CMS-authored `[footnote="..."]` keyword (see
 * QuestionnaireStepCubit's CustomFieldPropertyRegex.FOOTNOTE) below a
 * questionnaire step's button. `order: 90` positions it there among
 * QuestionnaireStep's flex-ordered children (button is 80, "Other" is 99).
 */
const QuestionnaireFootnote: FC<{ text?: string }> = (props) => {
  if (!props.text) {
    return null;
  }

  return <FootnoteText className="little1">{props.text}</FootnoteText>;
};

export default QuestionnaireFootnote;
